import { connect } from "react-redux"
import View from "./view"
import { Store } from "utilities/Redux/store"
import { getAcceptedOfferRequestIdsForBuyer } from "modules/Buyer/OfferRequests/selectors"

const mapStateToProps = (state: Store) => ({
  bookedOfferRequestIds: getAcceptedOfferRequestIdsForBuyer(state),
})

export default connect(mapStateToProps)(View)
